import { f as _objectSpread2 } from '../../_rollupPluginBabelHelpers-9YPQK5EO.js';
import { StrictMode } from 'react';
import { ApplicationProvider } from '../contexts/application-context.jsx';
import { jsx, Fragment } from 'react/jsx-runtime';

function App(_ref) {
  var children = _ref.children,
    owner = _ref.owner,
    providerOptions = _ref.providerOptions;
  return /*#__PURE__*/jsx(StrictMode, {
    children: /*#__PURE__*/jsx(ApplicationProvider, {
      owner: owner,
      children: /*#__PURE__*/jsx(CustomProviders, {
        providerOptions: providerOptions,
        children: children
      })
    })
  });
}
function CustomProviders(_ref2) {
  var children = _ref2.children,
    providerOptions = _ref2.providerOptions;
  if (!(providerOptions !== null && providerOptions !== void 0 && providerOptions.component)) {
    return /*#__PURE__*/jsx(Fragment, {
      children: children
    });
  }
  var Component = providerOptions.component,
    _providerOptions$prop = providerOptions.props,
    props = _providerOptions$prop === void 0 ? {} : _providerOptions$prop;
  return /*#__PURE__*/jsx(Component, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
}

export { App };
//# sourceMappingURL=app.jsx.map
